require("./bootstrap");

window.Vue = require("vue");

Vue.component(
    "site-loader",
    require("./components/frontend/SiteLoaderComponent").default
);
Vue.component(
    "site-header",
    require("./components/frontend/SiteHeaderComponent").default
);
// Vue.component(
//     "site-menu",
//     require("./components/frontend/SiteMenuComponent.vue").default
// );
Vue.component(
    "site-inner-banner",
    require("./components/frontend/SiteInnerBannerComponent.vue").default
);
Vue.component(
    "site-footer",
    require("./components/frontend/SiteFooterComponent.vue").default
);
// Vue.component(
//     "site-modal",
//     require("./components/frontend/SiteModalComponent.vue").default
// );
Vue.component(
    "site-index",
    require("./components/frontend/SiteIndexComponent.vue").default
);
Vue.component(
    "social",
    require("./components/frontend/SocialComponent.vue").default
);

window.App = new Vue({
    el: "#app",
    data: {
        host: "",
        siteConfig: "",
        companiesLength: 0,
        summaryData: "",
        detailsData: "",
        loader: false,
        limitPosition: 100,
        scrolled: false,
        lastPosition: 0,
        prevCompanyName: "",
        nextCompanyName: ""
    },
    methods: {
        getLink: function(name, id) {
            let obj = _.find(this.siteConfig.navs, function(o) {
                return o.name == name;
            });
            if (obj) {
                if (id) {
                    return obj.link.replace("id", id);
                }
                return obj.link;
            }
            return "";
        },
        getPreveousCompanyName(currentCompanyName) {
            var currentId = _.find(this.siteConfig.companies, {
                name: currentCompanyName
            }).id;
            if (currentId == 1) {
                var nextId = this.companiesLength;
            } else {
                var nextId = currentId - 1;
            }
            return _.find(this.siteConfig.companies, { id: nextId }).name;
        },
        getNextCompanyName(currentCompanyName) {
            var currentId = _.find(this.siteConfig.companies, {
                name: currentCompanyName
            }).id;
            if (currentId == this.companiesLength) {
                var nextId = 1;
            } else {
                var nextId = currentId + 1;
            }
            return _.find(this.siteConfig.companies, { id: nextId }).name;
        },
        getCompanyTootlip(id) {
            return _.find(this.siteConfig.companies, function(o) {
                return o.id == id;
            });
        },
        range: function(end, gap) {
            var ans = [];
            for (let i = 0; i <= end; i += gap) {
                ans.push(i);
            }
            return ans;
        },
        getGap: function() {
            var num = 100 / (this.companiesLength * 2);
            let precition = (num + "").split(".")[1];
            if (precition) {
                let re = new RegExp(
                    "^-?\\d+(?:.\\d{0," + (length || 2) + "})?"
                );
                return parseFloat(num.toString().match(re)[0]);
            }
            return parseFloat(num);
        },
        getTotal: function() {
            var gap = this.getGap();
            return 100 - gap;
        },
        getDeg: function() {
            return Math.floor(360 / this.companiesLength);
        },
        getSummary() {
            this.loader = true;
            axios
                .post(this.siteConfig.routes.summary, {
                    companies: this.siteConfig.companies
                })
                .then(response => {
                    this.summaryData = response.data;
                    this.loader = false;
                })
                .catch(error => {
                    console.log(error.response.data);
                });
        },
        getDetails(name) {
            if (name) {
                this.prevCompanyName = this.getPreveousCompanyName(name);
                this.nextCompanyName = this.getNextCompanyName(name);
                $("#js-modal-content").removeClass("js-animate");

                //this.loader = true;
                axios
                    .get(this.siteConfig.routes.details.replace("name", name))
                    .then(response => {
                        this.detailsData = response.data;
                        //this.loader = false
                        $("#js-modal-details").modal("show");
                        setTimeout(
                            () => $("#js-modal-content").addClass("js-animate"),
                            100
                        );
                    })
                    .catch(error => {
                        // this.loader = false;
                        console.log(error.response.data);
                    });
            }
        },
        handleScroll() {
            if (
                this.lastPosition < window.scrollY &&
                this.limitPosition < window.scrollY
            ) {
                this.scrolled = true;
                // move up!
            }

            if (this.lastPosition > window.scrollY) {
                this.scrolled = false;
                // move down
            }

            this.lastPosition = window.scrollY;
            // this.scrolled = window.scrollY > 250;
        }
    },
    created() {
        this.host = vueObj.appHost || "/";
        this.siteConfig = vueObj.siteConfig || "";
        if (this.siteConfig) {
            this.companiesLength = this.siteConfig.companies.length || 0;
        }
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    }
});
